import type { LRInitOptions } from '../types';

export default {
  logrocket: null as typeof import('logrocket') | null,
  executeIfEnabled(action: () => void): void {
    if (!this.logrocket) {
      return;
    }
    action();
  },
  async init(appID: string, options: LRInitOptions) {
    const LogRocket = (await import('logrocket')).default;

    this.logrocket = LogRocket;

    LogRocket.init(appID, options);
    LogRocket.getSessionURL(function (sessionURL) {
      console.warn('LogRocket sessionURL: ', sessionURL);
      window['logrocketSessionUrl'] = sessionURL;
    });
  },
  identify(uid: string, traits: any) {
    this.executeIfEnabled(() => {
      this.logrocket?.identify(uid, traits);
    });
  },
  log(...params: any[]) {
    this.executeIfEnabled(() => {
      this.logrocket?.log(...params);
    });
  },
  warn(...params: any[]) {
    this.executeIfEnabled(() => {
      this.logrocket?.warn(...params);
    });
  },
  info(...params: any[]) {
    this.executeIfEnabled(() => {
      this.logrocket?.info(...params);
    });
  },
  error(...params: any[]) {
    this.executeIfEnabled(() => {
      this.logrocket?.error(...params);
    });
  },
  track(eventName: string, eventProperties?: any) {
    this.executeIfEnabled(() => {
      this.logrocket?.track(eventName, eventProperties);
    });
  },
  captureException(error: Error) {
    this.executeIfEnabled(() => {
      this.logrocket?.captureException(error);
    });
  },
  captureMessage(message: string) {
    this.executeIfEnabled(() => {
      this.logrocket?.captureMessage(message);
    });
  }
};
